import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle, Ruler, RefreshCw, Sparkles, Clock, Eye, Shield, Truck } from 'lucide-react';
import { SEO } from '../components/SEO';
import { useTranslation } from 'react-i18next';

const faqData = {
  ru: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Ответы на популярные вопросы о наших украшениях',
    categories: [
      {
        title: 'О кольцах',
        questions: [
          {
            icon: Ruler,
            question: 'Как определить размер кольца?',
            answer: 'Для точного определения размера кольца мы рекомендуем посетить нас лично — у нас имеются специальные профессиональные инструменты для измерения. Также вы можете измерить внутренний диаметр кольца, которое вам подходит, и сообщить нам этот размер. Если вы делаете сюрприз, мы поможем подобрать размер по описанию или фото руки.'
          },
          {
            icon: RefreshCw,
            question: 'Можно ли изменить размер кольца после покупки?',
            answer: 'Да, это не проблема! Мы понимаем, что помолвочное кольцо часто дарится как сюрприз, и размер может не подойти идеально. После того как кольцо было подарено второй половинке, мы с радостью подгоним его под нужный размер. Эта услуга доступна для наших клиентов.'
          },
          {
            icon: Sparkles,
            question: 'Как ухаживать за кольцом с бриллиантом?',
            answer: 'Для сохранения блеска бриллианта рекомендуем: регулярно протирать кольцо мягкой тканью; раз в месяц очищать в тёплой воде с мягким мылом, используя мягкую зубную щётку; снимать кольцо при работе с химикатами, в спортзале и во время сна; хранить отдельно от других украшений, чтобы избежать царапин. Также мы предлагаем бесплатную профессиональную чистку раз в год!'
          }
        ]
      },
      {
        title: 'О заказе',
        questions: [
          {
            icon: Clock,
            question: 'Сколько времени занимает получение кольца?',
            answer: 'Некоторые изделия находятся у нас в наличии и доступны сразу — в каталоге видно, какие изделия отмечены как «В наличии». Те изделия, которые идут под заказ, изготавливаются индивидуально: в среднем с момента оформления заказа до получения изделия проходит 20-25 рабочих дней.'
          },
          {
            icon: Eye,
            question: 'Можно ли посмотреть кольцо перед покупкой?',
            answer: 'Да, конечно! Те кольца, которые есть в наличии, можно посмотреть перед покупкой по предварительной записи. Свяжитесь с нами по телефону +371 28448991 или оставьте запрос на сайте, и мы договоримся об удобном времени встречи.'
          },
          {
            icon: Truck,
            question: 'Как осуществляется доставка?',
            answer: 'Мы предлагаем бесплатную доставку на осмотр по всей Риге. При покупке — бесплатная доставка по всей Европе! По Риге доставка бесплатна как для осмотра, так и для покупки. По всей Европе — бесплатная доставка при покупке изделия.'
          }
        ]
      },
      {
        title: 'Гарантия и сервис',
        questions: [
          {
            icon: Shield,
            question: 'Какие гарантии вы предоставляете?',
            answer: 'Мы предоставляем полный пакет гарантий:\n\n• Гарантия 12 месяцев на все изделия\n• Бесплатная профессиональная чистка раз в год\n• 30 дней на обмен\n• Сертификат подлинности для каждого бриллианта\n• Гарантия качества изготовления\n\nМы уверены в качестве наших украшений и всегда готовы помочь нашим клиентам.'
          }
        ]
      }
    ]
  },
  lv: {
    title: 'Biežāk uzdotie jautājumi',
    subtitle: 'Atbildes uz populāriem jautājumiem par mūsu rotaslietām',
    categories: [
      {
        title: 'Par gredzeniem',
        questions: [
          {
            icon: Ruler,
            question: 'Kā noteikt gredzena izmēru?',
            answer: 'Precīzai gredzena izmēra noteikšanai mēs iesakām apmeklēt mūs personīgi — mums ir speciāli profesionāli instrumenti mērīšanai. Jūs varat arī izmērīt gredzena, kas jums der, iekšējo diametru un paziņot mums šo izmēru. Ja gatavojat pārsteigumu, mēs palīdzēsim izvēlēties izmēru pēc apraksta vai rokas fotogrāfijas.'
          },
          {
            icon: RefreshCw,
            question: 'Vai var mainīt gredzena izmēru pēc pirkuma?',
            answer: 'Jā, tā nav problēma! Mēs saprotam, ka saderināšanās gredzens bieži tiek dāvināts kā pārsteigums, un izmērs var nebūt ideāls. Pēc tam, kad gredzens ir uzdāvināts otrai pusītei, mēs ar prieku pielāgosim to vajadzīgajam izmēram. Šis pakalpojums ir pieejams mūsu klientiem.'
          },
          {
            icon: Sparkles,
            question: 'Kā kopt gredzenu ar dimantu?',
            answer: 'Lai saglabātu dimanta spīdumu, iesakām: regulāri slaucīt gredzenu ar mīkstu drānu; reizi mēnesī tīrīt siltā ūdenī ar maigu ziepēm, izmantojot mīkstu zobu birstīti; noņemt gredzenu, strādājot ar ķīmiskām vielām, sporta zālē un guļot; glabāt atsevišķi no citām rotaslietām, lai izvairītos no skrāpējumiem. Mēs arī piedāvājam bezmaksas profesionālu tīrīšanu reizi gadā!'
          }
        ]
      },
      {
        title: 'Par pasūtījumu',
        questions: [
          {
            icon: Clock,
            question: 'Cik ilgs laiks nepieciešams gredzena saņemšanai?',
            answer: 'Daži izstrādājumi ir mums noliktavā un pieejami uzreiz — katalogā redzams, kuri izstrādājumi ir atzīmēti kā «Noliktavā». Tie izstrādājumi, kas tiek izgatavoti pēc pasūtījuma, tiek izgatavoti individuāli: vidēji no pasūtījuma noformēšanas līdz izstrādājuma saņemšanai paiet 20-25 darba dienas.'
          },
          {
            icon: Eye,
            question: 'Vai var apskatīt gredzenu pirms pirkuma?',
            answer: 'Jā, protams! Tos gredzenus, kas ir noliktavā, var apskatīt pirms pirkuma, iepriekš pierakstoties. Sazinieties ar mums pa tālruni +371 28448991 vai atstājiet pieprasījumu vietnē, un mēs vienosimies par ērtu tikšanās laiku.'
          },
          {
            icon: Truck,
            question: 'Kā notiek piegāde?',
            answer: 'Mēs piedāvājam bezmaksas piegādi apskatei visā Rīgā. Pērkot — bezmaksas piegāde visā Eiropā! Rīgā piegāde ir bezmaksas gan apskatei, gan pirkumam. Visā Eiropā — bezmaksas piegāde, pērkot izstrādājumu.'
          }
        ]
      },
      {
        title: 'Garantija un serviss',
        questions: [
          {
            icon: Shield,
            question: 'Kādas garantijas jūs piedāvājat?',
            answer: 'Mēs piedāvājam pilnu garantiju paketi:\n\n• Garantija 12 mēneši visiem izstrādājumiem\n• Bezmaksas profesionāla tīrīšana reizi gadā\n• 30 dienas apmaiņai\n• Autentiskuma sertifikāts katram dimantam\n• Izgatavošanas kvalitātes garantija\n\nMēs esam pārliecināti par mūsu rotaslietu kvalitāti un vienmēr esam gatavi palīdzēt mūsu klientiem.'
          }
        ]
      }
    ]
  }
};

const FAQItem = ({ question, answer, icon: Icon, isOpen, onClick }) => {
  return (
    <div className="border border-border rounded-lg overflow-hidden mb-4">
      <button
        onClick={onClick}
        className="w-full px-6 py-4 flex items-center justify-between bg-background hover:bg-secondary/50 transition-colors duration-300"
      >
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon className="w-5 h-5 text-accent" />
          </div>
          <span className="font-body text-left text-lg">{question}</span>
        </div>
        <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="px-6 py-4 bg-secondary/30 border-t border-border">
              <p className="font-body text-muted-foreground whitespace-pre-line leading-relaxed">
                {answer}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const FAQ = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const content = faqData[lang] || faqData.ru;
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <div className="min-h-screen pt-32 pb-24" data-testid="faq-page">
      <SEO 
        title={content.title}
        description={content.subtitle}
      />

      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <HelpCircle className="w-8 h-8 text-accent" />
            <h1 className="font-heading text-4xl md:text-5xl tracking-tight">
              {content.title}
            </h1>
          </div>
          <p className="font-body text-lg text-muted-foreground">
            {content.subtitle}
          </p>
        </motion.div>

        {content.categories.map((category, categoryIndex) => (
          <motion.div
            key={categoryIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: categoryIndex * 0.1 }}
            className="mb-12"
          >
            <h2 className="font-heading text-2xl mb-6 tracking-tight text-accent">
              {category.title}
            </h2>
            {category.questions.map((item, questionIndex) => (
              <FAQItem
                key={questionIndex}
                question={item.question}
                answer={item.answer}
                icon={item.icon}
                isOpen={openItems[`${categoryIndex}-${questionIndex}`]}
                onClick={() => toggleItem(categoryIndex, questionIndex)}
              />
            ))}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
